import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ImportFileNewTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/ImportFileNewTemplatePage";
import Classes, { ACHTemplate, Company, CompanyAccount } from "model";

/**
 * @name CaptureFileImportNewTemplateColumn1Dropdown
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureFileImportNewTemplateColumn1Dropdown(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const selectedTemplate = ACHTemplate.init({
        id: ACHTemplate.nextID(),
        transactionType: "payment",
        secCode: "PPD Credit - Consumer Credit",
        name: "SamplePPD",
        companyDiscretionaryData: "",
        companyEntryDescription: "",
        creditAmount: "0.00",
        debitAmount: "0.00",
        achToParticipants: [],
        achFromAccount: [],
        company: Company.initByID(0),
        companyAccount: CompanyAccount.initByID(0),
        numberOfAccounts: "0"
    });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template" ], selectedTemplate)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "mapColumnSelect1", "isActive" ], true)
    .submit();

    return <ImportFileNewTemplatePage data={ data } ui={ ui } />;
}